var map = {
	"./de-DE.png": "/LSa",
	"./en-GB.png": "hDpc",
	"./en-US.png": "NWbU",
	"./es-ES.png": "hkf7",
	"./fr-FR.png": "+WCL",
	"./nl-BE.png": "tz1P",
	"./nl-NL.png": "wGY3",
	"./ru-RU.png": "x/lA",
	"./sv-SE.png": "soT5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BEQD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/country ^\.\/.*\.png$
// module id = BEQD
// module chunks = 1